module.exports = __webpack_public_path__ + "media/images/icon_list/sort_up-886319115234417ebe92c145f9acbf45.svg";